<template>
  <AppBarLayout>
    <template #default="{}">
      <div class="landing-page overflow-x-hide" @click="goHome">
        <div class="container no-padding">
          <div class="row no-margin">
            <div class="col-md-12" :style="{ 'min-height': dyn_height }">
              <div
                class="row no-padding main-body h-100"
                :style="{ height: windowHeight }"
              >
                <div class="col-md-12 row flex-container">
                  <brandpattern page="LANDING" />
                  <div class="text-container">
                    <div class="big-text">
                      {{ getUiText("user-temp-holding-heading-1") }}
                    </div>
                    <div class="small-text">
                      {{ getUiText("user-temp-holding-heading-sub-1") }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <errorhandler
              v-if="showProspectCallbackError || null"
              :prospect-callback-error-msg="prospectCallbackErrorMsg"
            />
          </div>
        </div>
      </div>
    </template>
  </AppBarLayout>
</template>
<script lang="ts">
import ActivePathWrapper from "@/components/common/activePathWrapper.vue";
import AppBarLayout from "@/components/layouts/appBarLayout.vue";
import { Component } from "vue-facing-decorator";
import { Vue } from "vue-facing-decorator";
import BrandPattern3 from "@/components/prospect/brandPattern/brandPattern3.vue";
import $ from "jquery";
import errorhandler from "@/components/common/exceptionHandler.vue";
import Utils from "@/utils/utilities";
import { load } from "recaptcha-v3";
import store from "@/store";
import { homeRoute } from "@/services/apiRoutes/routes";
import { localStorageBoolean } from "@/utils/constants";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
@Component({
  components: {
    brandpattern: BrandPattern3,
    errorhandler,
    ActivePathWrapper,
    AppBarLayout,
  },
})
export default class CreateAccount extends Vue {
  dyn_height = "0";
  disableButton = true;
  windowHeight = "";
  showPassword = false;
  enable_showpassword = false;
  public showProspectCallbackError = false;
  public prospectCallbackErrorMsg = "";

  get languageSelected() {
    return store.state.LanguagePicker.languageSelected;
  }
  get defaultUiText() {
    return store.state.LanguagePicker.defaultUiText;
  }
  get languageSelectedText() {
    return store.state.LanguagePicker.languageSelectedText;
  }
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
      this.onResize();
      this.setLanguages();
    });

    const body = $("body");
    if (!body.hasClass("page-opacity")) {
      body.addClass("page-opacity page-bg");
    }
    EventEmitter.emit(EmitterEvents.PAGE_LOADING_COMPLETED, true);
  }
  getUiText(id: string, isArray = false) {
    return Utils.getUiText(
      id,
      this.languageSelectedText,
      this.defaultUiText,
      isArray,
    );
  }

  async setLanguages() {
    await Utils.getV3Recaptcha().then(
      async (finalKey: any) => {
        localStorage.removeItem("csrfReloadDone");
        const captchKey = finalKey;
        const recaptcha = await load(`${captchKey}`, {
          autoHideBadge: true,
        });
        recaptcha.execute("submit").then((token) => {
          this.$store.dispatch("LanguagePicker/setLanguages", token);
        });
        recaptcha.execute("submit").then((token) => {
          this.$store.dispatch("LanguagePicker/setLanguageList", token);
        });
      },
      (error: any) => {
        if (error && error.data && error.data.error && error.data.error.type) {
          if (error.data.error.type === "exc_session_invalid-1") {
            sessionStorage.setItem(
              "prospectCallbackErrorInfo",
              JSON.stringify(error.data.error),
            );
            this.$router.push({ path: "/" });
          } else {
            this.showErrorInfo(error.data.error);
          }
        } else if (error.data.message === "invalid csrf token") {
          if (localStorage.getItem("csrfReloadDone") == null) {
            localStorage.setItem("csrfReloadDone", localStorageBoolean.true);
            this.$router.go(0);
          }
          sessionStorage.setItem(
            "prospectCallbackErrorInfo",
            JSON.stringify(error.data),
          );
          this.$router.push({ path: "/" });
        } else {
          this.showErrorInfo(error.data);
        }
      },
    );
  }

  showErrorInfo(errorInfo: any) {
    if (errorInfo && errorInfo !== "") {
      errorInfo =
        typeof errorInfo === "string" ? JSON.parse(errorInfo) : errorInfo;
      if (errorInfo && Object.keys(errorInfo).length > 0 && errorInfo.message) {
        this.showProspectCallbackError = true;
        this.prospectCallbackErrorMsg = errorInfo.message;
      }
    }
  }
  resetShowProspectCallbackError() {
    this.showProspectCallbackError = false;
    this.prospectCallbackErrorMsg = "";
  }

  onResize() {
    this.dyn_height = (window.innerHeight + "px") as string;
    this.windowHeight = "" + window.innerHeight + "px !important ";
  }
  goHome() {
    this.$router.replace({ path: homeRoute.homePage });
  }
  beforeUnmount() {
    const body = $("body");
    if (!body.hasClass("page-opacity")) {
      body.addClass("page-opacity page-bg page-shadow");
    }
  }
}
</script>

<style lang="scss" scoped>
.landing-page {
  background: #f7553c;
  overflow: hidden;

  .text-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 10px 10px 100px 350px;
  }
  .big-text {
    font-family: Poppins;
    font-style: normal;
    font-weight: 500;
    font-size: 42px;
    line-height: 140%;
    text-align: left;
    /* identical to box height, or 59px */
    display: flex;
    align-items: flex-start;

    /* UI / White */
    color: #ffffff;
  }

  .small-text {
    max-width: 558px;
    font-family: Poppins;
    font-style: normal;
    font-weight: normal;
    font-size: 22px;
    line-height: 170%;
    padding-top: 20px;
    /* or 37px */

    /* UI / White */
    color: #ffffff;
  }
}
@media (max-width: 768px) {
  .landing-page {
    .text-container {
      padding: 10px 10px 60px 100px;
    }
  }
}

@media (max-height: 500px) {
  .landing-page {
    .text-container {
      padding: 10px 10px 60px 100px;
    }
  }
}
@media (min-width: 3840px) {
  .landing-page {
    .text-container {
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 20px 20px 200px 700px;
    }
    .big-text {
      font-size: 84px !important;
      line-height: 140%;
    }

    .small-text {
      max-width: 1116px;
      font-family: Poppins;
      font-style: normal;
      font-weight: normal;
      font-size: 44px;
      line-height: 170%;
      padding-top: 40px;
      color: #ffffff;
    }
  }
}
</style>
